<div class="datacardCharts">
  <div class="loaderContainer" *ngIf="this.chatResp?.loader">
    <div class="loaderSpinner"></div>
</div>
<div>
  <div *ngIf="this.chatResp?.chart && !this.chatResp?.loader" echarts [options]="this.chatResp.chart"></div>
</div>
</div>
